export const GET_ALL_WIFI_DETAILS = 'GET_ALL_WIFI_DETAILS';
export const GET_COMPANY_NAME = 'GET_COMPANY_NAM';
export const GET_DEVICE_CHILDREN = 'GET_DEVICE_CHILDREN';
export const GET_ALL_SERIAL_PORT_MACHINES = 'GET_ALL_SERIAL_PORT_MACHINES_QUERY_KEY';
export const GET_SERIAL_PORT_CONFIGS = 'GET_SERIAL_PORT_CONFIGS';
export const GET_ALL_SERIAL_PORTS = 'GET_ALL_SERIAL_PORTS_QUERY_KEY';
